import { css } from "styled-components";
import {
  FontSizesValue,
  FontWeightValue,
  PxFontSize,
  typography,
} from "@shared/common/Themes/typography";
import { Color } from "@shared/common/Themes/types";

export type TypographyProps = {
  $ellipsis?: boolean;
  $weight?: FontWeightValue;
  $size?: PxFontSize | FontSizesValue | string;
  type?: TypographyType;
  color?: string;
};

export const sharedFontCss = css<TypographyProps>`
  font-size: ${(p) => {
    let fontSize: FontSizesValue = typography.fontSizes.M;
    if (p.$size) {
      if (p.$size.includes("px")) {
        fontSize = p.$size as FontSizesValue;
      } else {
        fontSize = typography.fontSizes[p.$size as PxFontSize];
      }
    }
    return fontSize;
  }};
  margin: 0;

  ${(p) => {
    if (!p.type) return ``;
    const color = p.theme.colors[TYPOGRAPHY_TYPE_TO_COLOR[p.type]];
    return `color: ${color};`;
  }}
  ${(p) =>
    p.color &&
    `
    color: ${p.color};
  `}
`;

export type TypographyType =
  | "primary"
  | "secondary"
  | "medium"
  | "danger"
  | "warning"
  | "success";

export const TYPOGRAPHY_TYPE_TO_COLOR: Record<TypographyType, Color> = {
  primary: "primaryText",
  secondary: "secondaryText",
  medium: "mediumText",
  danger: "red",
  warning: "gold",
  success: "green",
};
